import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack, go } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = 'bodega';

const LOADER_BODEGA = 'LOADER_BODEGA';
const SET_DATA_BODEGA = 'SET_DATA_BODEGA';
const SET_PAGE_BODEGA = 'SET_PAGE_BODEGA';
const SET_UPDATE_DATA_BODEGA ='SET_UPDATE_DATA_BODEGA';
const SET_BUSCADOR_BODEGA = 'SET_BUSCADOR_BODEGA';
const SET_FILTRO_BODEGA = 'SET_FILTRO_BODEGA';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_BODEGA, cargando: true});
    const store = getStore();
    const search = store.bodega.buscador;
    const filtro = store.bodega.filtro_bodega;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_BODEGA, data});
            dispatch({type: SET_PAGE_BODEGA, page});
        }
        dispatch({type: LOADER_BODEGA, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_BODEGA, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        if(error.statusCode  === 404){
            dispatch(go(-1))
        }
    }).then((data) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_BODEGA, updateData: data});
            dispatch(initializeForm('area', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.area.values);
    if(formData.cuenta){
        formData.cuenta = formData.cuenta.id
    }
    dispatch({type: LOADER_BODEGA, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_BODEGA, cargando: false})
        Swal('Éxito', 'Se ha creado correctamente.', 'success')
        .then(() => {
            dispatch(go(-1))
        })
    }).catch((error) => {
        dispatch({type: LOADER_BODEGA, cargando: false})
        let mensaje = 'Ha ocurrido un error, por favor vuelva a intentar.';
        if(error.detail){
            if(Array.isArray(error.detail)){
                mensaje = error.detail[0]
            }else{
                mensaje = error.detail
            }
        }
        Swal(
            'Error',
             mensaje,
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_BODEGA, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.area.values);
    dispatch({type: LOADER_BODEGA, cargando: true});
    if(formData.cuenta){
        formData.cuenta = formData.cuenta.id
    }
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(go(-1));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_BODEGA, cargando: false});
        let mensaje = 'Ha ocurrido un error, por favor vuelva a intentar.';
        if(error.detail){
            if(Array.isArray(error.detail)){
                mensaje = error.detail[0]
            }else{
                mensaje = error.detail
            }
        }
        Swal(
            'Error',
             mensaje,
            'error'
        );
        if(error.statusCode === 404){
            dispatch(go(-1));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_BODEGA, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_BODEGA, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_BODEGA, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_BODEGA, filtro_bodega: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_BODEGA]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_BODEGA]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_BODEGA]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_BODEGA]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_BODEGA]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_BODEGA]: (state, { filtro_bodega }) => {
        return {...state, filtro_bodega }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_bodega: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
